import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./PubMedSearchIndex.css";
import trackingService from "../../services/trackingService";
import GenerateArrayStrings from "../GenerateArrayStrings";
import { isEqual } from "underscore";

class PubMedLeftSearchBoxIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchKeyword: props.searchKeyword ? props.searchKeyword : '',
            appliedFilters: props.appliedFilters ? props.appliedFilters : [],
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            useTemplate: props.useTemplate ? props.useTemplate : "",
            selectedTab: props.selectedTab ? props.selectedTab : "-1",
            isAnyChangeAfterResult: props.isAnyChangeAfterResult ? props.isAnyChangeAfterResult : false,
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.searchKeyword != nextProps.searchKeyword) {
            this.setState({ searchKeyword: nextProps.searchKeyword })
        }
        if (this.state.isAnyChangeAfterResult != nextProps.isAnyChangeAfterResult) {
            this.setState({ isAnyChangeAfterResult: nextProps.isAnyChangeAfterResult })
        }
        if (this.state.useTemplate != nextProps.useTemplate) {
            this.setState({ useTemplate: nextProps.useTemplate })
        }
        if (!isEqual(this.state.appliedFilters, nextProps.appliedFilters)) {
            this.setState({
                appliedFilters: nextProps.appliedFilters
            })
        }
    }

    handleChangeInSearch = (event) => {
        this.setState({
            searchKeyword: event.target.value,
        })
    }

    handleKeyDown = async (event) => {
        if (['Enter'].includes(event.key) && !event.shiftKey && this.state.searchKeyword && this.state.searchKeyword.trim()) {
            event.preventDefault();
            event.returnValue = false;
            await this.handleOnClickSearchIcon();
        }
    }
    buildUrl = (searchKeyword, filters) => {
        searchKeyword = encodeURIComponent(searchKeyword);

        let filterStr = GenerateArrayStrings(filters)
        if (searchKeyword === undefined || filters === undefined) {
            return `/PubMedSearch?query=&filters=`;
        }
        else if (searchKeyword === '') {
            return `/PubMedSearch?query=&filters=${filterStr}`
        }
        else {
            return `/PubMedSearch?query=${searchKeyword}&filters=${filterStr}`;
        }


    }
    generateArrayString = (array) => {
        try {
            let arrStr = "";
            array.map((item, index) => {
                if (index === array.length - 1) {
                    arrStr += item;
                } else {
                    arrStr += item + ";";
                }
                return null;
            });
            return arrStr;
        } catch (error) {
            this.setState({ error: error });
        }
    };
    handleOnClickSearchIcon = () => {
        const queryParams = new URLSearchParams(document.location.search);
        let _searchKeyword = this.state.searchKeyword.trim();
        if (_searchKeyword) {
            if (this.state.selectedTab === '0') {
                const newUrl = this.buildUrl(_searchKeyword, this.state.appliedFilters);
                this.props.handleChangeInSearch(_searchKeyword, newUrl);
                this.props.history.push(newUrl);
            } else {
                this.props.handleChangeInSearch(_searchKeyword);
            }
            let { useTemplate } = this.state;
            let _eventaction = "PubMedGenAI2.0 Search in PubMed Tab";
            const filters = this.generateArrayString(this.state.appliedFilters);
            if (this.state.selectedTab === '1') {
                _eventaction = `PubMedGenAI2.0 Search with ${useTemplate} Template in Upload Abstracts Tab`;
            }
            else if (this.state.selectedTab === '2') {
                _eventaction = "PubMedGenAI2.0 Search in Review List Tab";
            }
            else if (this.state.selectedTab === '3') {
                _eventaction = "PubMedGenAI2.0 Refresh Search in Saved Searches Tab";
            }
            //let str = this.createSearchCriteriaString();
            //str = str.replace(/(")/g, '\\"');
            const ts = new trackingService();
            ts.indexTrackingData(
                localStorage.getItem("userdisplayName"),
                localStorage.getItem("wwid"),
                localStorage.getItem("username"),
                localStorage.getItem("function"),
                localStorage.getItem("region"),
                localStorage.getItem("userproducts"),
                localStorage.getItem("doctypepref"),
                localStorage.getItem("sid"),
                localStorage.getItem("deviceType"),
                localStorage.getItem("deviceOS"),
                localStorage.getItem("browserName"),
                localStorage.getItem("browserVersion"),
                localStorage.getItem("jnjDepartment"),
                localStorage.getItem("companyname"),
                _eventaction,
                "",
                this.buildUrl(_searchKeyword, this.state.appliedFilters),
                _searchKeyword,
                filters,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                this.props.csPath !== null ? this.props.csPath : "",
                this.props.csproduct !== null ? this.props.csproduct : ""
            );
        }
    }
    render() {
        if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
            return (<></>)
        }
        else if (this.props.customWidth > 1000) {
            return (<div className="pubmed-main-left-searchbox box-white">

                <div className="pubmed-main-left-textarea-section">
                    <div className="pubmed-main-left-textarea-label-section">
                        <span>Search query</span>
                        {(this.state.searchKeyword && this.state.selectedTab !== '3' && this.state.selectedTab !== '4') && <svg onClick={() => { this.setState({ searchKeyword: "" }) }} className="pubmed-main-left-textarea-label-clear" aria-hidden="true" focusable="false" height="1em" role="presentation" viewBox="0 0 24 24" width="1em">
                            <path d="M12 2a10 10 0 1010 10A10.016 10.016 0 0012 2zm3.36 12.3a.754.754 0 010 1.06.748.748 0 01-1.06 0l-2.3-2.3-2.3 2.3a.748.748 0 01-1.06 0 .754.754 0 010-1.06l2.3-2.3-2.3-2.3A.75.75 0 019.7 8.64l2.3 2.3 2.3-2.3a.75.75 0 011.06 1.06l-2.3 2.3z" fill="currentColor"></path>
                        </svg>}

                    </div>
                    <textarea className={(this.state.selectedTab === '3' || this.state.selectedTab === '4') ? "pubmed-main-left-textarea-box pubmed-main-left-textarea-box-not-allowed" : "pubmed-main-left-textarea-box"}
                        name="searchBar" placeholder="Ask a question.."
                        value={this.state.searchKeyword}
                        onChange={this.handleChangeInSearch}
                        onKeyDown={this.handleKeyDown} disabled={this.state.selectedTab === '3' || this.state.selectedTab === '4'} />
                </div>
                <div className= "pubmed-main-left-search-button-section">
                    <button className={this.state.selectedTab === '4' ? 'pubmed-main-left-search-button pubmed-main-left-textarea-box-not-allowed':"pubmed-main-left-search-button"} onClick={this.handleOnClickSearchIcon}
                    disabled={this.state.selectedTab === '4'}>
                        {this.state.selectedTab === '3' ? <>
                            <svg width="20px" data-icon="magnifying-glass" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M19.9381 13C19.979 12.6724 20 12.3387 20 12C20 7.58172 16.4183 4 12 4C9.49942 4 7.26681 5.14727 5.7998 6.94416M4.06189 11C4.02104 11.3276 4 11.6613 4 12C4 16.4183 7.58172 20 12 20C14.3894 20 16.5341 18.9525 18 17.2916M15 17H18V17.2916M5.7998 4V6.94416M5.7998 6.94416V6.99993L8.7998 7M18 20V17.2916" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </g>
                            </svg>
                            Refresh </> : <>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="magnifying-glass" className="svg-inline--fa fa-magnifying-glass" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ fontSize: "1 rem" }}>
                                <path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"></path>
                            </svg>
                            Search
                        </>}
                    </button>
                    {(this.state.selectedTab !== '0') &&
                        <button className="pubmed-main-left-reset-button" onClick={this.props.handleOnClickResetIcon} disabled={!this.state.isAnyChangeAfterResult}>
                            <svg fill="currentColor" className="svg-inline--fa fa-magnifying-glass" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" fill-rule="evenodd"></path>
                                </g>
                            </svg>
                            Reset
                        </button>}
                </div>
            </div>)
        }
    }

}
export default withRouter(PubMedLeftSearchBoxIndex);